import React, { useEffect } from 'react';
import images from '../images';
import styles from '../css/TopNavBar.module.scss'
import { DatoContacto } from './DatoContacto';
export const TopNavBar = () => {

    return (
        <nav id='topNavBar' class={"text-white py-1 text-end px-5 " + styles.topNavBar}>
            <DatoContacto dato={process.env.REACT_APP_WHATSAPP} logo={images.icons.whatsapp} isTopBar={true}/>
            <DatoContacto dato={process.env.REACT_APP_TELEFONO} logo={images.icons.telefono} className={'ms-5'} isTopBar={true}/>
        </nav>
    )

}
